import React, { Component } from "react";
import {  Row, Col, Button, Alert , Modal, ListGroup } from "react-bootstrap";
import "containers/common/List.css";
import ReactTable from "react-table";
import Creatable from 'react-select/creatable';
import Moment from "moment";


let alreadySorted = false;

export default class VolumeFoliosList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            dataSet: "volumeFolios",
            dataRecord: (['slmsale', 'slmlease'].includes(props.context)) ? "slmVolumeFolios" : "volumeFolios",
            dataSetPrimaryKey: "volume_folio_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        this.handleDeleteRecord = this.handleDeleteRecord.bind(this);
        this.sortData = this.sortData.bind(this);
    }

    async sortData(event) {
        // Sorting them all together was too complicated and wasn't working right
        // So sort each 'group' individually, concat, and use their IDs to do the final sort on this.props.data
        const vfsWithoutOther = [...this.props.data]
            .filter(vf => vf.volume && vf.folio)
            .sort((a, b) => (a.volume||'').localeCompare(b.volume, 'en', {numeric: true}) || (a.folio||'').localeCompare(b.folio, 'en', {numeric: true}));
        const vfsWithOther = [...this.props.data]
            .filter(vf => vf.other)
            .sort((a, b) => (a.other||'').localeCompare(b.other, 'en', {numeric: true}));
        const vfsWithNeither = [...this.props.data]
            .filter(vf => !vf.volume && !vf.folio && !vf.other)
            .sort((a, b) => a.volume_folio_id - b.volume_folio_id);
        const vfIds = [...vfsWithoutOther, ...vfsWithOther, ...vfsWithNeither].map(vf => vf.volume_folio_id);

        this.props.data.sort((a, b) => vfIds.indexOf(a.volume_folio_id) - vfIds.indexOf(b.volume_folio_id));
        this.forceUpdate();
    }

    async componentDidMount() {
        this.setState({ isLoading: true });

        if (!this.props.isAuthenticated) { // if false
            return;
        }

        this.setState({ isLoading: false });
    }

    componentDidUpdate(prevProps) {
        if (this.props.data.length > 0 && !alreadySorted) {
            this.sortData();
            alreadySorted = true;
        }
      }

    componentWillUnmount() {
        this.setState({ addresses: [] });
    }

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataRecord, this.state.dataSetPrimaryKey);
        } catch (e) {
            alert("Error saving");
        }
    }

    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();

        console.log("delete volume folios");

        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");

        if (r === true) {
            console.log(cellInfo);

            data[cellInfo.index].archived_date = new Date();

            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            });
        };
    };

    handleInputChange = (cellInfo, event) => {
        console.log('handleInputChange', cellInfo, event , data);
        let data = [...this.props.data];

        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleSave = async (cellInfo, event) => {
        const editedVolumeFolio = this.props.data[cellInfo.index];
        const columnName = cellInfo.column.id;
        console.log('handleSave', editedVolumeFolio, columnName);

        // Either (Volume or Folio), or Other
        if (['volume', 'folio'].includes(columnName) && (editedVolumeFolio.volume !== null && editedVolumeFolio.folio !== null && editedVolumeFolio.volume !== '' && editedVolumeFolio.folio !== '')) {
            editedVolumeFolio.other = null;
        }
        else if (columnName === 'other' && editedVolumeFolio.other) {
            editedVolumeFolio.volume = null;
            editedVolumeFolio.folio = null;
        }
        // not save data if only either volumn or folio being input
        else if (['volume', 'folio'].includes(columnName) && (editedVolumeFolio.volume == null || editedVolumeFolio.folio == null || editedVolumeFolio.volume == '' || editedVolumeFolio.folio == '')) {
            return;
        }

        const volumeFolios = [...this.props.data];
        console.log("volumeFolios", volumeFolios);
        for (let volumeFolio of volumeFolios) {
            // TODO validation rules using validateRelatedRecord

            // Save unnecessary API calls if the record wasn't modified
            if (!volumeFolio.hasOwnProperty('modified') || volumeFolio.modified === false) {
                continue;
            }

            const response = await this.handleDataSave(volumeFolio);

            if (response.result !== true) {
                this.setState({ errorMessage: response.error_message });
                this.setState({ showAlert: true });

                return;
            }

            volumeFolio.new_record = false;
            volumeFolio[this.state.dataSetPrimaryKey] = response.id;
        }

        // 'true' param = fromModal=true -- only updates the record that changed.
        // Otherwise the table gets sorted and it's disorienting.
        const newDataSet = await this.props.dataFetch(true);

        this.setState({ data: newDataSet });
    }

    addRecord = async event => {
        let data = [...this.props.data];
        let foreign_key = {key: 'property_id', value: this.props.filter.propertyid}

        if (this.props.context === 'slmsale') {
            foreign_key = {key: 'sale_id', value: this.props.filter.saleid}
        } else if (this.props.context === 'slmlease') {
            foreign_key = {key: 'lease_id', value: this.props.filter.leaseid}
        }

        data.push({
            // parcel_id: null,
            [foreign_key.key]: foreign_key.value,
            title_reference: null,
            volume: null,
            folio: null,
            other: null,
            created_by: this.props.user,
            last_edited_date: null,
            last_edited_by: this.props.user,
            archived_date: null,

            new_record: true
        });

        this.props.updateTableState(data, this.state.dataSet);
    }

    handleCopyRecord = async (cellInfo, event) => {
        console.log("handleCopyRecord()", cellInfo, event);
        event.preventDefault();


        let promptMessage = `How many copies do you want to create?`;
        const numCopies = parseInt(window.prompt(promptMessage));
        if (!numCopies) {
            return;
        }

        let data = [...this.props.data];
        let copies = [];

        for (let i = 0; i < numCopies; i++) {
            let copy = {...cellInfo.original};

            copy.volume_folio_id = null;
            copy.modified = true;
            copy.new_record = true;
            console.log(copy.folio);
            // Non-ACT behavour: increment Lot Number
            if (parseInt(copy.folio)) {
                if ((parseInt(copy.folio) + i + 1)<=999){
                    copy.folio = (parseInt(copy.folio) + i + 1).toString();
                }
            }

            copies.push(copy);
        }

        // Insert copies immediately after the original
        const copiedTitleDetailsIdx = data.findIndex(td => td.pavolume_folio_idrcel_id === cellInfo.original.volume_folio_id);
        data.splice(copiedTitleDetailsIdx + 1, 0, ...copies);

        await this.props.updateTableState(data, this.state.dataSet);
        this.handleSave(cellInfo, event);
    };

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        const trimmedCellValue = cellValue ? cellValue.trim() : "";
        if (cellInfo.column.id == "copyButton") {
            return (
                <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleCopyRecord(cellInfo,e)}>Copy</Button>
            )
        }else{
        return (
            <input
                onChange={(e) => {
                    const trimmedValue = e.target.value.trim();
                    this.handleInputChange(cellInfo, { target: { value: trimmedValue } });
                }}
                onBlur={(e) => {
                    const trimmedValue = e.target.value.trim();
                    this.handleSave(cellInfo, { target: { value: trimmedValue } });
                }}
                type="text"
                className="no-border form-control"
                style={{backgroundColor: (cellInfo.column.id === 'title_reference') ? 'lavender' : null}}
                value={trimmedCellValue}
            />
        )
        }
    }

    renderTable(data) {
        const columns = [
            {
                id: 'volume_folio_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'volume_folio_id'
            },
            {
                id: 'title_reference',
                Header: 'Title Reference',
                maxWidth: 200,
                accessor: 'title_reference',
                getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && column.id === 'title_reference' ? 'lavender' : null,
                        },
                    };
                },
                // Cell: this.renderEditable
            },
            {
                id: 'volume',
                Header: 'Volume',
                accessor: 'volume',
                maxWidth: 200,
                Cell: this.renderEditable
            },
            {
                id: 'folio',
                Header: 'Folio',
                accessor: 'folio',
                maxWidth: 200,
                Cell: this.renderEditable
            },
            {
                id: 'other',
                Header: 'Other',
                accessor: 'other',
                maxWidth: 200,
                Cell: this.renderEditable
            },
            {
                id: 'created_date',
                Header: 'Created Date',
                accessor: d => {
                    if (d.created_date === null) {
                        return null;
                    }
                    return Moment(d.created_date).local().format("DD-MM-YYYY")
                },
                maxWidth: 200,
            },
            {
                id: 'created_by',
                Header: 'Created By',
                accessor: 'created_by',
                maxWidth: 200,
            },
            {
                id: 'last_edited_date',
                Header: 'Last Edited Date',
                accessor: d => {
                    if (d.last_edited_date === null) {
                        return null;
                    }
                    return Moment(d.last_edited_date).local().format('DD-MM-YYYY');                },
                maxWidth: 200,
            },
            {
                id: 'last_edited_by',
                Header: 'Last Edited By',
                accessor: 'last_edited_by',
                maxWidth: 200,
            },
            {
                Header: '',
                accessor: 'parcel_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row,e)}>Delete</Button>
            },
            {
                id: 'copyButton',
                Header: '',
                accessor: 'property_id',
                maxWidth: 65,
                Cell: this.renderEditable //row => <div><Button type="button" size="sm" variant="primary" onClick={(e) => this.handleCopyRecord(row,e)}>Copy</Button></div>
            }
        ]

        if (!data) {
            return null
        } else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }
    }

    renderList(data, listAmount) {
        if (!data) {
            return null
        }
        else {
            let amt = 0

            if (listAmount) {
                amt = [...data].slice(0, parseInt(listAmount));
            } else {
                amt = [...data].slice(0, 5);
            }

            const latest = amt
            const volumeFolioStr = vf => {
                if (vf.volume && !vf.folio ) {
                    return (<span></span>);
                }
                else if (!vf.volume && vf.folio ) {
                    return (<span></span>);
                }
                else if (vf.volume && vf.folio ) {
                    return (<span>V{vf.volume} F{vf.folio}</span>);
                }
                else {
                return (<span>{vf.other}</span>);
                }
            }

            // return [{}].concat(latest).map(
            //     (d, i) =>
            //         i !== 0
            //             ?
            //             <ListGroup.Item key={i} as="a" header={d.volume_folio_id}>
            //                 { volumeFolioStr(d) }
            //             </ListGroup.Item>
            //             : ""
            // );
            return [{}].concat(latest).map(
                (d, i) =>
                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.title_reference}>
                            { volumeFolioStr(d) }
                        </ListGroup.Item>
                        : ""
            );
        }
    }

    renderComponent() {
        return (
            <div className="VolumeFolios">
                <Modal show={this.state.showAlert && this.props.data[this.props.data.length-1].volume_folio_id} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.state.showAlert && !this.props.data[this.props.data.length-1].volume_folio_id &&
                    <Alert variant="danger">{this.state.errorMessage}</Alert>
                }
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >
                        <Button variant="secondary" size="sm" onClick={this.sortData}>Refresh Sort</Button>&nbsp;
                        <Button variant="primary" size="sm" onClick={this.addRecord}>Add</Button>
                    </Col>
                </Row>}
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                            { !this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data, this.props.listAmount) }
                        </Col>
                    </Row>
            </div>
        );
    }

    render() {
        if (!this.props.data) {
            return null
        } else {
            return (
                <div className="AddressSection">
                    {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
                </div>
            );
        }
  }
}
